import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../types/analytics';

export const trackPublishWithVisibleViolationsClick = (product: object, offerStatus: TAnalyticsOfferStatus) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'click',
    label: 'violation_found',
    products: [product],
  });
};
